export default {
    // 中
    zhCN: {
        menu_maintenance: '菜单维护',
        role_name: '角色名称',
        role_key: '角色代码',
        role_id: '显示顺序',
        status: '状态',
        create_date: '创建时间',
        role_sort: '排序',
        role_new: '角色新增',
        role_edit: '角色编辑',
        role_bleak: '菜单',
    },
    // 英
    enUS: {
        menu_maintenance: 'Menu',
        role_name: 'Role name',
        role_key: 'Role code',
        role_id: 'Display order',
        status: 'status',
        create_date: 'Create time',
        role_sort: 'Sort',
        role_new: 'New role',
        role_edit: 'Edit role',
        role_bleak: 'Bleak',
    },
    // 德
    deDE: {
        menu_maintenance: 'Menüpflege',
        role_name: 'Rollenname',
        role_key: 'Berechtigungszeichen',
        role_id: 'Anzeigereihenfolge',
        status: 'Status',
        create_date: 'Erstellungszeit',
        role_sort: 'Sortieren',
        role_new: 'Neue Rolle',
        role_edit: 'Rolle bearbeiten',
        role_bleak: 'Düster',
    },
    // 法
    frFR: {
        menu_maintenance: 'Maintenance du menu',
        role_name: 'Nom de rôle',
        role_key: 'Caractère d\'autorisation',
        role_id: 'Ordre d\'affichage',
        status: 'Statut',
        create_date: 'Heure de création',
        role_sort: 'Trier',
        role_new: 'Nouveau rôle',
        role_edit: 'Modifier le rôle',
        role_bleak: 'Sombre',
    },
    // 意大利
    itIT: {
        menu_maintenance: 'Menu',
        role_name: 'Nome del Ruolo',
        role_key: 'Codice del Ruolo',
        role_id: 'Ordine di Visualizzazione',
        status: 'Stato',
        create_date: 'Data di Creazione',
        role_sort: 'Ordinamento',
        role_new: 'Nuovo Ruolo',
        role_edit: 'Modifica Ruolo',
        role_bleak: 'Menu',
    },
    // 荷兰
    nlNL: {
        menu_maintenance: 'Menu',
        role_name: 'Rollen Naam',
        role_key: 'Rechten Karakter',
        role_id: 'Weergave volgorde',
        status: 'Status',
        create_date: 'Aanmaak datum',
        role_sort: 'Sorteren',
        role_new: 'Nieuwe Rol',
        role_edit: 'Rol bewerken',
        role_bleak: 'Leegmaken',
    },
    // 越南
    viVN: {
        menu_maintenance: 'Bảo trì menu',
        role_name: 'Tên vai trò',
        role_key: 'Mã vai trò',
        role_id: 'Thứ tự hiển thị',
        status: 'Trạng thái',
        create_date: 'Thời gian tạo',
        role_sort: 'Sắp xếp vai trò',
        role_new: 'Thêm mới vai trò',
        role_edit: 'Chỉnh sửa vai trò',
        role_bleak: 'Menu',
    },
    // 西班牙
    esES: {
        menu_maintenance: 'Mantenimiento de menús',
        role_name: 'Nombre del rol',
        role_key: 'Código del rol',
        role_id: 'Orden de visualización',
        status: 'Estado',
        create_date: 'Fecha de creación',
        role_sort: 'Ordenar',
        role_new: 'Añadir rol',
        role_edit: 'Editar rol',
        role_bleak: 'Menú',
    },
    // 葡萄牙
    ptBR: {
        menu_maintenance: 'Manutenção do menu',
        role_name: 'Nome do papel',
        role_key: 'Código do papel',
        role_id: 'Ordem de exibição',
        status: 'Status',
        create_date: 'Data de criação',
        role_sort: 'Ordenação do papel',
        role_new: 'Novo papel',
        role_edit: 'Editar papel',
        role_bleak: 'Menu',
    },
    // 波兰
    plPL: {
        menu_maintenance: 'Menu',
        role_name: 'Nazwa roli',
        role_key: 'Kod roli',
        role_id: 'Kolejność wyświetlania',
        status: 'Status',
        create_date: 'Czas założenia',
        role_sort: 'Sortowanie',
        role_new: 'Nowa rola',
        role_edit: 'Edytuj rolę',
        role_bleak: 'Menu',
    },
    // 土耳其
    trTR: {
        menu_maintenance: 'Menü koruması',
        role_name: 'Rol İsmi',
        role_key: 'Rol Kodu',
        role_id: 'Gösterim Sırası',
        status: 'Durum',
        create_date: 'Zaman Oluşturma',
        role_sort: 'Sırala',
        role_new: 'Yeni Rol',
        role_edit: 'Rol Düzenle',
        role_bleak: 'Menü',
    },
    // 捷克语
    csCZ: {
        menu_maintenance: 'Nabídka',
        role_name: 'Název role',
        role_key: 'Kód role',
        role_id: 'Zobrazení objednávky',
        status: 'status',
        create_date: 'Čas vytvoření',
        role_sort: 'Seřadit',
        role_new: 'Nová role',
        role_edit: 'Upravit roli',
        role_bleak: 'Nabídka',
    },
    // 匈牙利语
    huHU: {
        menu_maintenance: 'Menü',
        role_name: 'Szerepnév',
        role_key: 'Szerepkód',
        role_id: 'Megjelenítési sorrend',
        status: 'Állapot',
        create_date: 'Létrehozás ideje',
        role_sort: 'Rendezés',
        role_new: 'Új szerep',
        role_edit: 'Szerep módosítása',
        role_bleak: 'Üres',
    },
    // 俄罗斯语
    ruRU: {
        menu_maintenance: 'Управление меню',
        role_name: 'Название роли',
        role_key: 'Код роли',
        role_id: 'Порядок отображения',
        status: 'Статус',
        create_date: 'Дата создания',
        role_sort: 'Сортировка',
        role_new: 'Новая роль',
        role_edit: 'Редактирование роли',
        role_bleak: 'Меню',
    },
    // 沙特阿拉伯 (阿拉伯语)
    arSA: {
        menu_maintenance: 'صيانة القائمة',
        role_name: 'اسم الدور',
        role_key: 'رمز الدور',
        role_id: 'ترتيب العرض',
        status: 'الحالة',
        create_date: 'تاريخ الإنشاء',
        role_sort: 'الترتيب',
        role_new: 'إضافة دور جديد',
        role_edit: 'تحرير الدور',
        role_bleak: 'القائمة',
    },
    // 保加利亚语
    bgBG: {
        menu_maintenance: 'Поддръжка на менюто',
        role_name: 'Име на ролята',
        role_key: 'Ключ на ролята',
        role_id: 'Последователност за показване',
        status: 'Статус',
        create_date: 'Дата на създаване',
        role_sort: 'Подреждане',
        role_new: 'Нова роля',
        role_edit: 'Редактиране на роля',
        role_bleak: 'Меню',
    },
    // 丹麦语
    daDK: {
        menu_maintenance: 'Menuvedligeholdelse',
        role_name: 'Rollenavn',
        role_key: 'Rolletast',
        role_id: 'Visningsrækkefølge',
        status: 'Status',
        create_date: 'Oprettelsesdato',
        role_sort: 'Sortering',
        role_new: 'Ny rolle',
        role_edit: 'Redigér rolle',
        role_bleak: 'Menu',
    },
    // 芬兰语
    fiFI: {
        menu_maintenance: 'Valikon ylläpito',
        role_name: 'Roolin nimi',
        role_key: 'Roolikoodi',
        role_id: 'Näyttöjärjestys',
        status: 'Tila',
        create_date: 'Luontiaika',
        role_sort: 'Lajittelu',
        role_new: 'Uusi rooli',
        role_edit: 'Muokkaa roolia',
        role_bleak: 'Valikko',
    },
    // 繁体中文（台湾）
    zhTW: {
        menu_maintenance: '選單維護',
        role_name: '角色名稱',
        role_key: '角色代碼',
        role_id: '顯示順序',
        status: '狀態',
        create_date: '創建時間',
        role_sort: '排序',
        role_new: '新增角色',
        role_edit: '編輯角色',
        role_bleak: '選單',
    },
    // 克罗地亚语
    hrHR: {
        menu_maintenance: 'Održavanje izbornika',
        role_name: 'Naziv uloge',
        role_key: 'Kôd uloge',
        role_id: 'Redoslijed prikaza',
        status: 'Status',
        create_date: 'Datum stvaranja',
        role_sort: 'Poredak',
        role_new: 'Nova uloga',
        role_edit: 'Uređivanje uloge',
        role_bleak: 'Izbornik',
    },
    // 拉脱维亚语
    lvLV: {
        menu_maintenance: 'Izvēlnes uzturēšana',
        role_name: 'Lomas nosaukums',
        role_key: 'Lomas kods',
        role_id: 'Attēlošanas secība',
        status: 'Statuss',
        create_date: 'Izveidošanas datums',
        role_sort: 'Kārtot',
        role_new: 'Jauna loma',
        role_edit: 'Rediģēt lomu',
        role_bleak: 'Izvēlne',
    },
    // 立陶宛语
    ltLT: {
        menu_maintenance: 'Meniu priežiūra',
        role_name: 'Rolės pavadinimas',
        role_key: 'Rolės kodas',
        role_id: 'Rodymo eilės numeris',
        status: 'Būsena',
        create_date: 'Sukūrimo data',
        role_sort: 'Rūšiavimas',
        role_new: 'Nauja rolė',
        role_edit: 'Redaguoti rolę',
        role_bleak: 'Meniu',
    },
    // 罗马尼亚语
    roRO: {
        menu_maintenance: 'Meniu de întreținere',
        role_name: 'Nume rol',
        role_key: 'Cod rol',
        role_id: 'Ordine afișare',
        status: 'Stare',
        create_date: 'Data creării',
        role_sort: 'Sortare',
        role_new: 'Adăugare rol',
        role_edit: 'Editare rol',
        role_bleak: 'Meniu',
    },
    // 挪威博克马尔语
    nbNO: {
        menu_maintenance: 'Menyvedlikehold',
        role_name: 'Rolletittel',
        role_key: 'Rollekode',
        role_id: 'Visningsrekkefølge',
        status: 'Status',
        create_date: 'Opprettelsesdato',
        role_sort: 'Sortering',
        role_new: 'Ny rolle',
        role_edit: 'Rediger rolle',
        role_bleak: 'Meny',
    },
    // 葡萄牙语（巴西）
    ptBX: {
        menu_maintenance: 'Manutenção de menu',
        role_name: 'Nome da função',
        role_key: 'Código da função',
        role_id: 'Ordem de exibição',
        status: 'Status',
        create_date: 'Data de criação',
        role_sort: 'Ordenação',
        role_new: 'Nova função',
        role_edit: 'Editar função',
        role_bleak: 'Menu',
    },
    // 瑞典语
    svSE: {
        menu_maintenance: 'Menyhantering',
        role_name: 'Rollnamn',
        role_key: 'Rollkod',
        role_id: 'Visningsordning',
        status: 'Status',
        create_date: 'Skapelsedatum',
        role_sort: 'Sortering',
        role_new: 'Ny roll',
        role_edit: 'Redigera roll',
        role_bleak: 'Meny',
    },
    // 斯洛伐克语
    skSK: {
        menu_maintenance: 'Údržba ponuky',
        role_name: 'Názov role',
        role_key: 'Kód role',
        role_id: 'Poradie zobrazenia',
        status: 'Stav',
        create_date: 'Dátum vytvorenia',
        role_sort: 'Zoradenie',
        role_new: 'Nová rola',
        role_edit: 'Úprava roly',
        role_bleak: 'Ponuka',
    },
    // 斯洛文尼亚语
    slSI: {
        menu_maintenance: 'Vzdrževanje menija',
        role_name: 'Ime vloge',
        role_key: 'Koda vloge',
        role_id: 'Zaporedje prikaza',
        status: 'Stanje',
        create_date: 'Datum ustvarjanja',
        role_sort: 'Razvrščanje',
        role_new: 'Nova vloga',
        role_edit: 'Urejanje vloge',
        role_bleak: 'Meni',
    },
    // 泰语
    thTH: {
        menu_maintenance: 'บำรุงรักษาเมนู',
        role_name: 'ชื่อบทบาท',
        role_key: 'รหัสบทบาท',
        role_id: 'ลำดับการแสดงผล',
        status: 'สถานะ',
        create_date: 'เวลาสร้าง',
        role_sort: 'เรียงลำดับ',
        role_new: 'เพิ่มบทบาทใหม่',
        role_edit: 'แก้ไขบทบาท',
        role_bleak: 'เมนู',
    },
    // 乌克兰语
    ukUA: {
        menu_maintenance: 'Обслуговування меню',
        role_name: 'Назва ролі',
        role_key: 'Код ролі',
        role_id: 'Порядок відображення',
        status: 'Стан',
        create_date: 'Дата створення',
        role_sort: 'Сортування',
        role_new: 'Нова роль',
        role_edit: 'Редагувати роль',
        role_bleak: 'Меню',
    },
    // 希腊语
    elGR: {
        menu_maintenance: 'Συντήρηση μενού',
        role_name: 'Όνομα ρόλου',
        role_key: 'Κωδικός ρόλου',
        role_id: 'Σειρά εμφάνισης',
        status: 'Κατάσταση',
        create_date: 'Ημερομηνία δημιουργίας',
        role_sort: 'Ταξινόμηση',
        role_new: 'Νέος ρόλος',
        role_edit: 'Επεξεργασία ρόλου',
        role_bleak: 'Μενού',
    },
    // 爱沙尼亚语
    etEE: {
        menu_maintenance: 'Menüü hooldus',
        role_name: 'Rolli nimi',
        role_key: 'Rolli kood',
        role_id: 'Kuvamise järjestus',
        status: 'Olek',
        create_date: 'Loomise kuupäev',
        role_sort: 'Sorteerimine',
        role_new: 'Uus roll',
        role_edit: 'Muuda rolli',
        role_bleak: 'Menüü',
    },
    // 哈萨克语
    kkKZ: {
        menu_maintenance: 'Мәзірді техникалық қызмет көрсету',
        role_name: 'Рөл атауы',
        role_key: 'Рөл коды',
        role_id: 'Көрсету реті',
        status: 'Күйі',
        create_date: 'Құрылған күні',
        role_sort: 'Сұрыптау',
        role_new: 'Жаңа рөл',
        role_edit: 'Рөлді түзету',
        role_bleak: 'Мәзір',
    },
    // 希伯来语
    heIL: {
        menu_maintenance: 'תחזוקת תפריט',
        role_name: 'שם תפקיד',
        role_key: 'קוד תפקיד',
        role_id: 'סדר תצוגה',
        status: 'סטטוס',
        create_date: 'תאריך יצירה',
        role_sort: 'מיון',
        role_new: 'תפקיד חדש',
        role_edit: 'עריכת תפקיד',
        role_bleak: 'תפריט',
    },
};
